<template>
    <el-button-group v-if="bimSaatavilla">
        <el-button size="small" :loading="loading" @click="avaa">
            {{ nappiteksti }}
        </el-button>
        <ComTooltip content="Päivitä vertailu">
            <el-button size="small" :loading="fetching" @click="paivita">
                <el-icon><Refresh /></el-icon>
            </el-button>
        </ComTooltip>
    </el-button-group>
</template>

<script lang="ts">
export default {
    name: "ComMalliNappi",
}
</script>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue"
import { Refresh } from "@element-plus/icons-vue"
import ComTooltip from "@/components/common/ComTooltip.vue"
import { useBimMallit } from "@/methods/bimComposables"
import { bimKaytossa } from "@/bim-http"
import * as malliIkkuna from "./malliIkkuna"
import { useMalliLinkki } from "./malliLinkki"

interface Props {
    hankeId: number
}

const props = defineProps<Props>()
const hankeId = computed(() => props.hankeId)

/** Nappi nakyy jos hankkeelle on malli. Tarkistetaan mallirekisterista eika
 *  vertailusta: vertailu hakee kaikki hankkeen huonekortit, eika sita saa
 *  tehda pelkan napin nakyvyyden takia. */
const { mallit } = useBimMallit()
const bimSaatavilla = computed(
    () => bimKaytossa && !!mallit.value?.some((m) => m.hankeId === hankeId.value || m.oletus)
)

// avaaMalli tulee malliLinkista, joka on myos ainoa paikka joka tyontaa
// paivittyneen vertailun avoimeen ikkunaan ("Paivita vertailu" -nappi).
const { loading, fetching, paivita, avaaMalli } = useMalliLinkki(hankeId)

/** `malliIkkuna.auki()` ei ole reaktiivinen — ikkunan sulkeminen ei laukaise
 *  Vahdissa tapahtumaa. Tila luetaan siksi klikkausten yhteydessa ja
 *  ikkunaan kohdistuvien tapahtumien jalkeen. */
const ikkunaAuki = ref(false)
const nappiteksti = computed(() => (ikkunaAuki.value ? "Näytä malli" : "Avaa malli"))

const avaa = () => {
    avaaMalli()
    ikkunaAuki.value = malliIkkuna.auki()
}

// Ikkunan sulkemisesta ei tule Vahtiin tapahtumaa, joten nappiteksti
// tarkistetaan kun kayttaja palaa Vahtiin. Ilman tata nappi lupaisi
// "Nayta malli" ikkunalle jota ei enaa ole.
const tarkistaIkkuna = () => { ikkunaAuki.value = malliIkkuna.auki() }
onMounted(() => {
    tarkistaIkkuna()
    window.addEventListener("focus", tarkistaIkkuna)
})
onBeforeUnmount(() => window.removeEventListener("focus", tarkistaIkkuna))
</script>
